<script setup lang="ts">
const config = useAppConfig()

const {value} = defineProps<{ value?: any }>()
</script>

<template>
  
</template>

<style scoped>

</style>
